import SessionCard from './SessionCard.component';

export default SessionCard;